export const GoogleMapsAPIKey = "AIzaSyCb_xtYTdy7pw6uMJzYxQAyO6hD8BuRvh0";
export const GoogleTagsKey = "0000G-0Z86R8";
export const GoogleCaptchaKey = '6LcjkmAoAA0000==-=QKVoqK_rnh4';